import { FiInfo } from 'react-icons/fi';
import { useNavigate } from 'react-router-dom';

import { Card } from '@/components';
import ROUTES from '@/router/routes';
import { ResponseTdeRankingData } from '@/types/tde';
import { cn } from '@/utils';

const TournamentAlertCard = ({
  schooldata,
  isParticipatingInTournament,
  isPrimary,
}: {
  schooldata: ResponseTdeRankingData;
  isParticipatingInTournament: boolean;
  isPrimary: boolean;
}) => {
  const tournamentTitle = isPrimary
    ? 'Torneo de Escuelas Primarias'
    : 'Torneo de Escuelas Secundarias';

  const navigate = useNavigate();

  const goToCompleteData = () => {
    navigate(ROUTES.editAccount.myData, {
      state: {
        selectedScreen: 'MyData',
        returnPage: ROUTES.primarySchoolTournament,
        scrollTo: 'school-section',
      },
    });
  };

  if (!schooldata.tieneEdad) {
    return (
      <Card className={cn('p-0 bg-white w-[426px] ml-8 px-5 pt-6 pb-3')}>
        <div className="flex items-center space-x-2 ml-4">
          <FiInfo className="text-gdt-blue" size={24} />
          <p className="font-bold text-[16px]">{tournamentTitle}</p>
        </div>
        <div className="px-4 py-2">
          <p className="text-[14px]">
            El torneo de escuelas es un sub-torneo en el cual pueden participar,
            individualmente o con su escuela, todos aquellos usuarios que estén{' '}
            <span className="font-bold">
              {isPrimary
                ? 'cursando el colegio primario.'
                : 'cursando el colegio secundario.'}
            </span>
          </p>
        </div>
      </Card>
    );
  }

  if (isParticipatingInTournament) return null;

  return (
    <Card className={cn('p-0 bg-white w-[426px] ml-8 px-5 pt-6 pb-3')}>
      <div className="flex items-center space-x-2 ml-4">
        <FiInfo className="text-gdt-blue" size={24} />
        <p className="font-bold text-[16px]">{tournamentTitle}</p>
      </div>
      <div className="px-4 py-2">
        <p className="text-[14px]">
          Completá el nombre de tu escuela en{' '}
          <span
            className="text-gdt-blue underline cursor-pointer whitespace-normal break-words"
            onClick={goToCompleteData}
          >
            tus datos personales
          </span>{' '}
          de Gran DT y participá todas las fechas por una{' '}
          <span className="font-bold">PELOTA DE FÚTBOL</span> y por un{' '}
          <span className="font-bold">SMARTPHONE</span> si sos el mejor del
          Torneo.
        </p>
      </div>
    </Card>
  );
};

export default TournamentAlertCard;
